import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IToolbarActionDefinition } from "../../../../../utils/emails";
import Menu from "../../../components/Menu";
import { MenuItemAdapter } from "../MenuItemAdapter";
import { LexicalEditor } from "lexical";

type CustomActionProperties =
{
    editor: LexicalEditor
    action: IToolbarActionDefinition
    onClick: (item: MenuItemAdapter) => void
}

export default function CustomAction({ action, editor, onClick }: CustomActionProperties)
{
    switch (action.type)
    {
        case 'divider':
            return <div className="divider" />;
        case 'button':
            return <button type="button" className="btn" onClick={() => { action.onSelected?.(editor); }} title={action.text}>
                {action.icon && <FontAwesomeIcon icon={action.icon} />} {action.text}
            </button>;
        default:
            return <Menu item={new MenuItemAdapter(action)} root={true} onClick={onClick} />;
    }
}